import React from "react";
import "./LivoraFeedback.css";

function LivoraToast({ toast }) {
  if (!toast?.show) return null;

  return (
    <div className={`livora-toast ${toast.type || "success"}`}>
      {toast.message}
    </div>
  );
}

export default LivoraToast;